import React from "react";
import { isNonEmptyArray } from "../../../../../../utils";
import CustomAccordion from "../../../../../accordion/CustomAccordion";
import styles from "./DeliverablesPhasesList.module.css";
import { DeliverablesList } from "..";
import { CustomTooltip } from "../../../../../tooltip";
import { icon, IconComponent } from "../../../../../icon-component";

const DeliverablesPhasesList = ({ hasFilters, onChange, onExpandPhase, phases, readOnly, selection }) =>
	isNonEmptyArray(phases) &&
	[...phases]
		.filter((phase) => phase.deliverablesCount > 0)
		.map((phase) => {
			const isExpanded = phase?.deliverablesCount > 0 || phase?.deliverables?.length > 0;
			return (
				<CustomAccordion
					key={phase.phaseId}
					className={styles.accordionContent}
					defaultOpen={hasFilters || phase.defaultExpanded}
					header={
						<CustomTooltip showWhenOverflow title={phase?.phaseName}>
							<div className={styles.line} data-phase-locked={phase?.lockedOrArchived}>
								{phase?.phaseName}
								{phase?.lockedOrArchived && (
									<IconComponent color="var(--grey-500)" icon={icon.faLock} />
								)}
							</div>
						</CustomTooltip>
					}
					iconColor="var(--grey-500)"
					onExpand={() => onExpandPhase({ expandablePhase: phase })}
				>
					{(isExpanded && !phase?.lockedOrArchived && (
						<DeliverablesList
							deliverables={phase.deliverables}
							readOnly={readOnly}
							selection={selection}
							onChange={onChange}
						/>
					)) ||
						null}
				</CustomAccordion>
			);
		});

export default DeliverablesPhasesList;
